import type { MetricTrend } from '@fluenceur/types';

/**
 * Which way a metric has to move for the move to be good news.
 * `neutral` passes no verdict: the change is shown, never judged.
 */
export type TrendPolarity = 'higherIsBetter' | 'lowerIsBetter' | 'neutral';

/** What a change means for the reader, which is what decides its colour. */
export type TrendTone = 'good' | 'bad' | 'neutral';

/**
 * Reads a direction through a metric's polarity. Defaults to `higherIsBetter`,
 * which is how every trend was coloured before polarity existed.
 */
export const trendTone = (
  direction: MetricTrend['direction'],
  polarity: TrendPolarity = 'higherIsBetter'
): TrendTone => {
  if (direction === 'flat' || polarity === 'neutral') return 'neutral';
  const rose = direction === 'up';
  if (polarity === 'higherIsBetter') return rose ? 'good' : 'bad';
  return rose ? 'bad' : 'good';
};
